import React, { Component } from 'react';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Axios from '../../../axios';
import firebase from 'firebase';

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: {
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: 'Input your title'
        },
        value: ''
      },
    };
    this.database = firebase.database();
  }

  addCategory = () => {
    if (
      this.state.title.value.trim().length === 0
    )
      return;
    const category = {
      title: this.state.title.value.trim()
    };
    this.database.ref('category').push().update(category)
  };

  render() {
    return (
      <div>
        <p>Add Category</p>
        <Input
          elementType={this.state.title.elementType}
          elementConfig={this.state.title.elementConfig}
          value={this.state.title.value}
          changed={event =>
            this.setState({
              title: {
                ...this.state.title,
                value: event.target.value
              }
            })
          }
        />
        <Button onClicked={this.addCategory}>Add Category</Button>
      </div>
    );
  }
}
